const twoDGFrmtr = (val) => {
  return val < 10 ? "0" + val : val; //return 0 appended string if val is less than 10
};

export const secondsToHHMMSS = (value) => {
  const sec = parseInt(value, 10); // convert value to number if it's string
  let hours = twoDGFrmtr(Math.floor(sec / 3600)); // get hours
  let minutes = twoDGFrmtr(Math.floor((sec - hours * 3600) / 60)); // get minutes
  let seconds = twoDGFrmtr(sec - hours * 3600 - minutes * 60); //  get seconds
  const duration =
    hours === "00"
      ? minutes + ":" + seconds
      : hours + ":" + minutes + ":" + seconds;
  return duration;
};

export const secondsToDhms = (seconds) => {
  seconds = Number(seconds);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);

  var dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
  var hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
  var mDisplay = m > 0 ? m + (m === 1 ? " minute, " : " minutes, ") : "";
  var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";
  return dDisplay + hDisplay + mDisplay + sDisplay;
};

export const epochToTime = (epochTime) => {
  const matchDate = new Date(epochTime * 1000);
  return (
    twoDGFrmtr(matchDate.getUTCDate()) +
    "/" +
    twoDGFrmtr(matchDate.getUTCMonth() + 1) +
    "/" +
    twoDGFrmtr(matchDate.getUTCFullYear()) +
    "\xa0\xa0" +
    twoDGFrmtr(matchDate.getUTCHours()) +
    ":" +
    twoDGFrmtr(matchDate.getUTCMinutes())
  );
};

export const TZtoDate = (tzValue) => {
  const matchDate = new Date(tzValue);
  return (
    twoDGFrmtr(matchDate.getUTCDate()) +
    "/" +
    twoDGFrmtr(matchDate.getUTCMonth()) +
    "/" +
    twoDGFrmtr(matchDate.getUTCFullYear())
  );
};

export const openInNewTab = (url) => {
  window.open(url, "_blank");
};

export const sortByKey = (array, key) => {
  return array.sort((a, b) => {
    var x = a[key];
    var y = b[key];
    return x < y ? -1 : x > y ? 1 : 0;
  });
};
